import { css } from '@creditas/stylitas'

import {
  rtNamespace,
  rtMobile,
  rtToastMaxHeight,
  rtToastMinHeight,
} from './variables'

const toast = css`
  .${rtNamespace}__toast {
    border-radius: 1px;
    border-radius: 4px;
    box-shadow: 0px 8px 16px 0px rgba(170, 187, 187, 0.5);
    box-sizing: border-box;
    direction: ltr;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    max-height: ${rtToastMaxHeight};
    min-height: ${rtToastMinHeight};
    overflow: hidden;
    line-height: 24px;
    position: relative;
    background-color: white;

    &--rtl {
      direction: rtl;
    }
    &--default {
    }
    &--info {
    }
    &--success {
    }
    &--warning {
    }
    &--error {
    }
    &-body {
      flex: 1;
    }
  }

  @media ${rtMobile} {
    .${rtNamespace}__toast {
      margin-bottom: 0;
    }
  }
`

export { toast }
